import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    height: 10vh;
    padding: 0 3%;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 550px) {
        height: 8vh;
    }

    @media (max-width: 550px) and (max-height: 800px) {
        height: 6vh;
    }

    .currentClueText{
        margin-top: 7px;
        text-align: center;
        font-size: 1.4rem;
        max-height: 90%;
        overflow: auto;
        color: ${({ theme }) => theme.text };

        @media (max-width: 550px) {
            margin-top: 5px;
        }

        @media (max-width: 550px) and (max-height: 800px) {
            margin-top: 4px;
        }
    }
    
    .caretIcon{
        cursor: pointer;
    }
`;